module.exports = __webpack_public_path__ + "img/item1-8.adb1ca8d.jpg";